import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Topico, Conversa, Mensagem, ChatBot } from '../../models/chat-bot.model';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ChatBotService } from '../../services/chat-bot.service';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent extends BaseListComponent<Topico> implements OnInit {

  suggestions:{ id: number, label: string, textoBase: string }[] =[];
  options:Topico[] = [];
  
  idLoading:boolean = false;
  showChat:boolean = false;
  showFull:boolean = false;
  active:boolean = false;
  currentSearch:string = '';
  currentTopico:number|null = null;
  currentSubTopico:number|null = null;
  currentMsgError:string = '';
  showTextArea:boolean = false;
  baseData: ChatBot = 
    { nome:'Assistente SMG', 
      textoBotao:'Consulte o Assistente SMG', 
      legenda:'Converse com a IA do SMG', 
      primeiraMensagem:'Olá! Sou o Assistente SMG e estou aqui para ajudar você a utilizar o sistema', 
      logo:'assets/images/quero.png' };
  messages: Conversa[]  = [];
  loadMessage: string[] = [
    'Pensando',
    'Refletindo',
    'Processando',
    'Organizando ideias',
    'Quase lá',
    'Desculpe o atraso, estou finalizando',
    'Isso está demorando, obrigado pela paciência',
    'Pensando com calma, resposta chegando',
    'Aguarde um pouco mais, quase pronto',
    'Refletindo profundamente, só um instante'
  ];


  @ViewChildren('messageSession') sectionRefs!: QueryList<ElementRef>;
  @ViewChild('chatMessage') chatRefs!: ElementRef;
  @ViewChild('inputMessage') inputRefs!: ElementRef;

  constructor(
    private cdRef: ChangeDetectorRef,
    private storageService: StorageService,
    private myService: ChatBotService,
  ) { 
    super();
  }

  ngOnInit() {
    this.start();
    // pega o id da session
    this.getSessionId();

  }
  
  ngAfterViewInit(): void {
   
    setTimeout(() => this.checkSizes());

    this.sectionRefs.changes.subscribe(() => {
      setTimeout(() => this.checkSizes());
      this.scrollToBottom();
    });
  }

  
  start(): void {
    this.myService.findAll().subscribe({
      next: (res: Topico[]) => {
        this.active = true; 
        this.options = res;
        this.messages.push({
            autor: 'ia',
            texto: this.baseData.primeiraMensagem,
          })
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
      },
    })
  }


  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = "auto";
    textarea.style.height = textarea.scrollHeight + "px";
  }

  getSessionId(): void {
    /*
    this.sessionId = this.storageService.getChatSessionId();
    console.log(this.sessionId)
    if(!this.sessionId){
      this.chatSidebarService.inicia().subscribe({
        next: (res:ChatSidebar) => {
          console.log(res?.sessionId)
          this.sessionId = res?.sessionId ?? null;
          this.storageService.setChatSession(this.sessionId);
        },
        error: (error:any) => {
          this.idLoading = false;
          console.log(error)
        }
      });
    }*/
  }

  handleEnter(event: any): void {
    if (!event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  setLoadMessage(){
    let index = 0;
    this.currentMsgError = this.loadMessage[index];
    var intervalId = setInterval(() => {
      index = (index + 1) % this.loadMessage.length;
      this.currentMsgError = this.loadMessage[index];
    }, 4000);
  }
  sendMessage(): void {
    this.messages.push({
      autor: 'user',
      texto:this.currentSearch
    });
    this.idLoading = true;
    this.showTextArea = false;
    this.setLoadMessage();
    const payload = { id: this.currentSubTopico, pergunta: this.currentSearch};
    this.myService.perguntar(payload).subscribe({
      next: (res:any) => {
        /*
        const add = res.similaridade < 80? 'O mais próximo que encontrei a sua pergunta foi: ': '';
        this.messages.push({
          autor: 'ia',
          texto: add + res.resposta,
        })*/
       this.messages.push({
          autor: 'ia',
          texto: 'Sua dúvida foi registrada com sucesso! Assim que recebermos um retorno, você será avisada por e-mail e também notificada aqui no sistema',
        })
        this.setHelpMessage();
        this.idLoading = false;
      },
      error: (error:any) => {
        this.idLoading = false;
        const msg = error?.error?.[0]?.message ?? 'Infelizmente ainda não consigo responder sobre isso. Entre em contato com o suporte ou consulte o tutorial para esclarecer sua dúvida.'
        this.messages.push({
          autor: 'ia',
          texto: msg,
          referencia: [],
        })
      }
    });
    this.currentSearch = '';

  }


  copyToClipboard(text: string, index?: number): void {
    text += " Essa mensagem foi gerada pelo GPTDoe - Para acessar a informação oficial consulte o https://www.diariooficial.rs.gov.br/";
    navigator.clipboard.writeText(text).then(
      () =>{
        if(index){
          this.messages[index].showCopyText = true;
          setTimeout(() => {
            this.messages[index].showCopyText = false;
          }, 2000);
        }
      }
    );
  }

  
  checkSizes(): void {
    this.sectionRefs.forEach((ref, index) => {
      const element = ref.nativeElement as HTMLElement;
      const alturaReal = element.scrollHeight;
      this.messages[index].excedeLimite = alturaReal > 200;
    });
  }

  toggleExpand(index:number): void {
    this.messages[index].expandido = !this.messages[index].expandido;
    setTimeout(() => this.cdRef.detectChanges());
  }
  toggleExpandReference(index:number): void {
    this.messages[index].referenciaExpandida = !this.messages[index].referenciaExpandida;
    setTimeout(() => this.cdRef.detectChanges());
  }

  private scrollToBottom(): void {
    try {
      const container = this.chatRefs.nativeElement as HTMLElement;
      container.scrollTop = container.scrollHeight;
    } catch (err) {
      console.error('Erro ao rolar pro final:', err);
    }
  }
  get subTopicos(): Topico[] {
    const topico = this.options.find(o => o.id == this.currentTopico);
    return topico?.faq_topico_many_ativo ?? [];
  }
  get questions(): Mensagem[] {
    const topico = this.options.find(o =>  o.id == this.currentTopico);
    const subTopico = topico?.faq_topico_many_ativo?.find(o => o.id == this.currentSubTopico);
    return subTopico?.faq_pergunta_ativo;
  }

  setVoltar():void {
    if(this.currentSubTopico){
      this.currentSubTopico = null;
    }
    else if(this.currentTopico){
      this.currentTopico = null;
    }
    this.messages.push({
      autor: 'user',
      texto:'Voltar.'
    });
  }

  setTopico(topico:Topico):void {
    this.currentTopico = topico.id;
    this.messages.push({
      autor: 'user',
      texto:'Quero falar sobre '+ topico.rotulo + '.'
    });
    
    this.idLoading = true;
    setTimeout(() => {
      this.messages.push({
        autor: 'ia',
        texto: 'Certo, qual o assunto?'
      });
      this.idLoading = false;
    }, 1000);
  }

  setSubTopico(subTopico:Topico):void {
    this.currentSubTopico = subTopico.id;
    this.messages.push({
      autor: 'user',
      texto: subTopico.rotulo + '.'
    });
    this.idLoading = true;
    setTimeout(() => {
      this.messages.push({
        autor: 'ia',
        texto: 'Ok, identifiquei as seguintes dúvidas já cadastradas. Pode selecionar uma delas, ou digitar sua perguna!',
        options: this.questions
      });
      this.idLoading = false;
    }, 1000);
  }


  setOption(option:Mensagem): void{
    this.messages.push({
      autor: 'user',
      texto: option.pergunta
    });
    this.idLoading = true;
    setTimeout(() => {
      this.messages.push({
        autor: 'ia',
        texto: option.resposta
      });
    }, 1000);
    this.setHelpMessage();
  }

  setHelpMessage(): void{
    setTimeout(() => {
      this.messages.push({
        autor: 'ia',
        texto: 'Posso te ajudar em mais alguma coisa?',
        options: this.questions
      });
      this.idLoading = false;
    }, 1000);
  }
  openSupport():void{
    const msg = 'Gostaria de pedir ajuda para o suporte.';
    this.messages.push({
      autor: 'user',
      texto: msg
    });
    this.idLoading = true;
    setTimeout(() => {
      const iaMsg = 'Claro! Por favor, descreva sua dúvida para que eu possa encaminhá-la ao suporte.\nO prazo de resposta pode ser de até 10 dias úteis.';
      this.messages.push({
        autor: 'ia',
        texto: iaMsg
      });
      this.showTextArea = true
      this.idLoading = false;
    }, 1000);
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    //substitui a msg copiada no ctrl + c , colocando um alerta
    if (event.ctrlKey && event.key === 'c') {
      const selection = window.getSelection();
      if (!selection) return;
      //só faz se estiver copiando msg do bot, senão manter a msg que ele copiou
      const range = selection.getRangeAt(0);
      let container = range.commonAncestorContainer as Node;
      if (container.nodeType === Node.TEXT_NODE) {
        container = container.parentNode as HTMLElement;
      }
      const botElement = (container as HTMLElement).closest('.bot-message');
      const text = selection.toString() || '';
      if (botElement && text) {
        event.preventDefault();
        this.copyToClipboard(text);
      }
    }
  }
  closeChat(){
    console.log(this.showFull)
    if(this.showFull){
      this.showChat = false;
      this.showFull = false;
    }
  }
  setTextByVoice(event: any){
    this.currentSearch = event;
  }
}